import { ITemplateDiseaseOptions, ITemplateOptionsDetailResModel } from '@/util/Request/agrialert/requestType';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment, { Moment } from 'moment';

export enum ForecastOrHistoricalSelectedEnum{
    FORECAST = 'Forecast',
    HISTORICAL = 'Historical',
    MIXFORECASTHISTORICAL = 'ForecastAndHistorical'
}

export enum AgronomicTypeEnum{
    SPRAY = 'SprayRecommendation',
    PLANTING = 'PlantingRecommendation',
    DISEASE = 'DiseaseRisk',
    STRESS = 'StressAlert',
    HEATSTRESSRISK= 'HeatStressRisk',
    COLDSTRESSRISK = 'ColdStressRisk'
}

export enum DiseaseCropEnum{
    APPLES = 'Apples',
    CEREAL = 'Cereal',
    CORN = 'Corn',
    CANOLA = 'Canola',
    GRAPES = 'Grapes',
    PEPPER = 'Pepper',
    POTATO = 'Potato',
    SUNFLOWER = 'Sunflower',
    TURF = 'Turf'
}

export enum TimePeriodEnum{
    SEVEN = '7days',
    FOURTEEN = '14days',
    CUSTOM = 'custom',
    FORECAST = 'forecast'
}

/**
 * 1. 一项只对应一个 Forecast 或 Histirocal
 * 2. 该项中，时期对应多个 Disease，只要这个 Diseae 选过了，那么就不会出现在别的选项中了
 */
export interface IAgronomicItemModel{
    SprayRecommendation?: IRecommendationModel;
    PlantingRecommendation?: IRecommendationModel;
    DiseaseRisk?: IRecommendationModel;
    StressAlert?: IRecommendationModel;
    HeatStressRisk?: IRecommendationModel;
    ColdStressRisk?: IRecommendationModel;
}

export interface IRecommendationModel{
    forecastOrHistoricalSelected: ForecastOrHistoricalSelectedEnum; // 选择的是 Historical 还是 Forecast
    isForecast?: boolean; // 默认可以显示 Foreacst 按钮，当里面的 Options 全部选过了就不能选
    isHistorical?: boolean; // 默认可以显示 Historical 按钮，当里面的 Options 全部选过了就不能选
    isMixedForecastHistorical?: boolean;

    cropValue?: string; // spray, planting and heat uses this for crop, diseas is crop type
    cropOptions?: ITemplateOptionsDetailResModel[];

    diseaseCropValue?: string;
    diseaseValue?: string
    diseaseOptions?: ITemplateDiseaseOptions[]
    forecastDays?: number,
    historicalDays?: number,
    // 下面全是给 Historical 用的，看选的是历史的几天
    historicalTimeSelected? : TimePeriodEnum;
    historicalStartDate?: string;
    historicalEndDate?: string;
    disableStartDate?: RangePickerProps['disabledDate']
    disableEndDate?: RangePickerProps['disabledDate']
}






export interface IAllAgronomicModel{
    sortNumber: number;
    data?: IAgronomicItemModel;
    agronomicValue?: string;
    uuid?: string;
}

// Remainder value
export interface ISprayRemainderModel{
    'forecast'?: ITemplateOptionsDetailResModel[];
    'historical'?: ITemplateOptionsDetailResModel[];
}

export interface IPlantingRemainderModel{
    'forecast'?: ITemplateOptionsDetailResModel[];
    'historical'?: ITemplateOptionsDetailResModel[];
}
export interface IDiseaseRemainderModel{
    'forecast'?: {
        'Apples'?: ITemplateDiseaseOptions[];
        'Canola'?: ITemplateDiseaseOptions[];
        'Cereal'?: ITemplateDiseaseOptions[];
        'Corn'?: ITemplateDiseaseOptions[];
        'Grapes'?: ITemplateDiseaseOptions[];
        'Pepper'?: ITemplateDiseaseOptions[];
        'Potato'?: ITemplateDiseaseOptions[];
        'Sunflower'?: ITemplateDiseaseOptions[];
        'Turf'?: ITemplateDiseaseOptions[];
    }
    'historical'?: {
        'Apples'?: ITemplateDiseaseOptions[];
        'Canola'?: ITemplateDiseaseOptions[];
        'Cereal'?: ITemplateDiseaseOptions[];
        'Corn'?: ITemplateDiseaseOptions[];
        'Grapes'?: ITemplateDiseaseOptions[];
        'Pepper'?: ITemplateDiseaseOptions[];
        'Potato'?: ITemplateDiseaseOptions[];
        'Sunflower'?: ITemplateDiseaseOptions[];
        'Turf'?: ITemplateDiseaseOptions[];
    }
}

export const forecastDiseaseOptions = [
    'Bruchid',
    'ConventionalSmithBlight',
    'EarlyBlight',
    'FrostAlert',
    'HeatStress',
    'HuttonBlight',
    'TarSpot'
];

// init func

export const initSprayFunc = (initSprayOptions: ITemplateOptionsDetailResModel[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        cropOptions : initSprayOptions,
        isHistorical : false,
        // valueForHistoricalOptions : initSprayOptions,
        cropValue : null,
        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current > moment().endOf('day');
        },
        disableEndDate: current => {
            return current && current > moment().endOf('day');
        }
    };
};

export const initPlantingFunc = (initPlantingOptions: ITemplateOptionsDetailResModel[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        cropOptions : initPlantingOptions,
        isHistorical : true,
        // valueForHistoricalOptions : initPlantingOptions,
        cropValue : null,
        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current > moment().endOf('day');
        },
        disableEndDate: current => {
            return current && current > moment().endOf('day');
        }
    };
};

export const initDiseaseFunc = (initCropOptions: string[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        isHistorical : true,

        cropOptions: null,
        diseaseValue: null,
        diseaseOptions: null,

        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current >= moment().startOf('day');
        },
        disableEndDate: current => {
            return current && current >= moment().startOf('day');
        }
    };
};

export const initStressAlertFunc = (initStressAlertOptions: ITemplateOptionsDetailResModel[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        cropOptions : initStressAlertOptions,
        isHistorical : true,
        cropValue : null,
        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current > moment().endOf('day');
        },
        disableEndDate: current => {
            return current && current > moment().endOf('day');
        }
    };
};

export const initHeatStressRiskFunc = (initHeatStressRiskOptions: ITemplateOptionsDetailResModel[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        cropOptions : initHeatStressRiskOptions,
        isHistorical : true,
        cropValue : null,
        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current > moment().endOf('day');
        },
        disableEndDate: current => {
            return current && current > moment().endOf('day');
        }
    };
};

export const initColdStressRiskFunc = (initColdStressRiskOptions: ITemplateOptionsDetailResModel[]):IRecommendationModel=>{
    return {
        forecastOrHistoricalSelected : null,
        isForecast : true,
        cropOptions : initColdStressRiskOptions,
        isHistorical : true,
        cropValue : null,
        historicalTimeSelected: null,
        historicalStartDate: null,
        historicalEndDate: null,
        disableStartDate: current => {
            return current && current > moment().endOf('day');
        },
        disableEndDate: current => {
            return current && current > moment().endOf('day');
        }
    };
};

